var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 14.6693C11.6806 14.6693 14.6654 11.6845 14.6654 8.0026C14.6654 4.32071 11.6806 1.33594 7.9987 1.33594C4.3168 1.33594 1.33203 4.32071 1.33203 8.0026C1.33203 11.6845 4.3168 14.6693 7.9987 14.6693ZM6.92129 5.74668C6.59585 5.42125 6.06821 5.42125 5.74278 5.74668C5.41734 6.07212 5.41734 6.59976 5.74278 6.92519L6.82019 8.0026L5.74278 9.08001C5.41734 9.40545 5.41734 9.93309 5.74278 10.2585C6.06821 10.584 6.59585 10.584 6.92129 10.2585L7.9987 9.18112L9.07611 10.2585C9.40155 10.584 9.92918 10.584 10.2546 10.2585C10.5801 9.93309 10.5801 9.40545 10.2546 9.08002L9.17721 8.0026L10.2546 6.92519C10.5801 6.59976 10.5801 6.07212 10.2546 5.74668C9.92918 5.42125 9.40155 5.42125 9.07611 5.74668L7.9987 6.82409L6.92129 5.74668Z",
    fill: "#252919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackClose);
export default __webpack_public_path__ + "static/media/black-close.6db123c869c88d021d151cf38b1acd79.svg";
export { ForwardRef as ReactComponent };